import { $win } from './utils';

export default function subscribeUI() {
	$('.js-subscribe-form').on('submit', function(event) {
		event.preventDefault();

		const $form = $(this);
		const $email = $form.find('.js-subscribe-email-field');
		const url = $form.data('href');

		localStorage.setItem('email', $email.val());

		window.location.href = url;
	});

	const storedValue = localStorage.getItem('email');

	if ($('.section-form input[type="email"]').length && storedValue) {
		const $field = $('.section-form input[type="email"]');
		const $section = $field.closest('.section-form');
		const offset = -100;

		$field.val(storedValue);

		$win.on('load', () => {
			$('html, body').animate({
				scrollTop: $section.offset().top + offset
			}, 1000);
		});
	}

	localStorage.removeItem('email');
}
